import { NgClass } from "@angular/common";
import { Component, inject } from "@angular/core";

import { RippleModule } from "primeng/ripple";

import { GlobalService } from "@shared/services";

@Component({
  selector: "app-clickable-card",
  standalone: true,
  imports: [RippleModule, NgClass],
  templateUrl: "./clickable-card.component.html",
  styleUrl: "./clickable-card.component.scss",
})
export class ClickableCardComponent {
  globalService = inject(GlobalService);
}
